export default __webpack_public_path__ + "static/layer782-b57f6e276e626f77a5b6d975da0c5969.jpg";